import React from 'react';
import { MDBBtn, MDBCard, MDBCardBody, MDBCarousel,MDBMask,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBTestimonial,MDBContainer, MDBCardImage, MDBCardTitle, MDBCardText, MDBCol, MDBRow, MDBTypography, MDBCardHeader, MDBCardFooter, MDBFooter, MDBView } from 'mdbreact';
import './products.css'
import { Placeholder, Segment } from 'semantic-ui-react'
const Card = () => {
  return (
    <div>
      
      <section className="text-center"
      style={{backgroundImage:"url(http://labartisan.net/demo/chashi/assets/images/feature/shape/01.png)",
      backgroundPosition: "right",
      backgroundRepeat:" no-repeat",
      backgroundSize: "450px",

     }} >
    <MDBContainer>
     <h1>
Why we?
</h1>
<h3>
The Leader of all Milk
Safe and Healthy Milk Since 1975
</h3>
<br  />
     <MDBRow>
         <MDBCol className="" md="4">
         <br/>
                <MDBCard
                className="card-image hoverable">
                  <center>
                    <br/><img src="http://labartisan.net/demo/gowala/assets/images/about/06.png"
                   style={{
               
                     height:"120px",
                     width:"142px",
                    }}/></center>
                 <MDBCardBody >
                     <br />
                     <MDBCardTitle>
                                Farm
                  Technological Leader

                     </MDBCardTitle>
                     <MDBCardText>Continually productize compelling
                          quality for packed with all Elated Themes.
                         </MDBCardText>
                 </MDBCardBody>
             </MDBCard>
            
         </MDBCol>
       
         <MDBCol  md="4">
         <br/>
         
             <MDBCard
             className="card-image hoverable">
                        <center> <br/><img src="http://labartisan.net/demo/gowala/assets/images/about/02.png"
                   style={{
               
                     height:"120px",
                     width:"142px",
                    }}/></center>
                     
                 <MDBCardBody>
                     <MDBCardTitle 
                     >
                         Nature Milk For Making Ghee</MDBCardTitle>
                     <MDBCardText>Continually productize compelling 
                         quality for packed with all Elated Themes. 
                         Setting up to website and creating pages.</MDBCardText>
                 </MDBCardBody>
             </MDBCard>
         </MDBCol>
         <MDBCol  md="4">
         <br/>
             <MDBCard
             className="card-image hoverable" >
                        <center> <br/><img src="http://labartisan.net/demo/gowala/assets/images/about/03.png"
                   style={{
               
                     height:"120px",
                     width:"142px",
                    }}/></center>
                     
                      
                  
                 <MDBCardBody >
                     <MDBCardTitle>
                      
                        Convenient Delivery System
                        </MDBCardTitle>
                        <MDBCardText>Continually productize compelling 
                         quality for packed with all Elated Themes. 
                         Setting up to website and creating pages.</MDBCardText>
                 </MDBCardBody>
             </MDBCard>
         </MDBCol>
     </MDBRow>
    </MDBContainer>  
    </section>
    <section className="my-5 text-center">
    <MDBContainer>
    <h1>
our products
</h1>
<h3>
The Leader of all Milk
Safe and Healthy Milk Since 1975
</h3>
    <MDBRow  className="my-3">
      <MDBCol>
      <br/>
      <MDBCard className="card-image hoverable"  style={{
             
             backgroundImage:
               "url(http://www.visakhadairy.com/images/p13.jpg)",
               backgroundPosition: "right",
               backgroundRepeat:" no-repeat",
               backgroundSize: "150px",
               paddingRight:'120px'
               }}>
        
        <MDBCardBody>
          <MDBCardTitle>Card title</MDBCardTitle>
          <MDBCardText >
            Some quick example text to build on the card title and make
            up the bulk of the card&apos;s content.
          </MDBCardText>
        </MDBCardBody>
        </MDBCard>

        <br/>
      <MDBCard className="card-image hoverable"  style={{
             
                backgroundImage:
                  "url(http://www.visakhadairy.com/images/p1.jpg)",
                  backgroundPosition: "right",
                  backgroundRepeat:" no-repeat",
                  backgroundSize: "150px",
                  paddingRight:'120px'
                  }}>
        
        <MDBCardBody >
          <MDBCardTitle>Card title</MDBCardTitle>
          <MDBCardText >
            Some quick example text to build on the card title and make
            up the bulk of the card&apos;s content.
          </MDBCardText>
        </MDBCardBody>
        </MDBCard>
      </MDBCol> 
      <MDBCol >
      <br/>
      <MDBCard className="card-image hoverable"  style={{
             
                backgroundImage:
                  "url(http://labartisan.net/demo/chashi/assets/images/feature/06.png)",
                  backgroundPosition: "right",
                  backgroundRepeat:" no-repeat",
                  backgroundSize: "150px",
                  paddingRight:'120px'
                  }}>
        
        <MDBCardBody>
          <MDBCardTitle>Card title</MDBCardTitle>
          <MDBCardText >
            Some quick example text to build on the card title and make
            up the bulk of the card&apos;s content.
          </MDBCardText>
        </MDBCardBody>
        </MDBCard>

      <br />
      <MDBCard className="card-image hoverable"  style={{
             
                backgroundImage:
                  "url(http://labartisan.net/demo/chashi/assets/images/feature/05.png)",
                  backgroundPosition: "right",
                  backgroundRepeat:" no-repeat",
                  backgroundSize: "150px",
                  paddingRight:'120px'
                  }}>
        
        <MDBCardBody >
          <MDBCardTitle>Card title</MDBCardTitle>
          <MDBCardText >
            Some quick example text to build on the card title and make
            up the bulk of the card&apos;s content.
          </MDBCardText>
        </MDBCardBody>
        </MDBCard>
      </MDBCol> 
    <br/>
      <MDBCol>
      <br/>
      <MDBCard className="card-image hoverable"  style={{
             
                backgroundImage:
                  "url(http://labartisan.net/demo/chashi/assets/images/feature/06.png)",
                  backgroundPosition: "right",
                  backgroundRepeat:" no-repeat",
                  backgroundSize: "150px",
                  paddingRight:'120px'
                
                  }}>
        
        <MDBCardBody>
          <MDBCardTitle>Card title</MDBCardTitle>
          <MDBCardText >
            Some quick example text to build on the card title and make
            up the bulk of the card&apos;s content.
          </MDBCardText>
        </MDBCardBody>
        </MDBCard>

      <br />
      <MDBCard className="card-image hoverable" style={{
             
             backgroundImage:
               "url(http://labartisan.net/demo/chashi/assets/images/feature/05.png)",
               backgroundPosition: "right",
               backgroundRepeat:" no-repeat",
               backgroundSize: "150px",
               paddingRight:'120px'
               }}>
        
        <MDBCardBody >
          <MDBCardTitle>Card title</MDBCardTitle>
          <MDBCardText >
            Some quick example text to build on the card title and make
            up the bulk of the card&apos;s content.
          </MDBCardText>
        </MDBCardBody>
        </MDBCard>
      </MDBCol> 
    
    </MDBRow>
  <br/>

  </MDBContainer>
   </section>
   <section  style={{
             
             backgroundImage:
               "url(http://dairy-farm.ancorathemes.com/wp-content/uploads/2016/09/3-layers.jpg?id=195)",
               backgroundPosition: "right",
               backgroundRepeat:" no-repeat",
               backgroundSize:"cover"
               
             
               }}> 
  <MDBContainer >
    <MDBRow className="my-5" >
      <MDBCol >
        <img 
        src="http://dairy-farm.ancorathemes.com/wp-content/uploads/2016/09/image1_1.png"
        height="300px"
        className="my-5 mr-4 p-4"
      
        />
      </MDBCol>
      <MDBCol className="justify-content-center my-5">
      <h1 className=" teal-text">Feautured Product</h1><hr className="red"/>
        <h1 className="text-white">The Only Ice Cream Recipe You'll Ever Need</h1>
      <p className="text-white">Although any mammal can produce milk, commercial dairy farms are typically one-species enterprises. In developed countries, dairy farms typically consist of high producing dairy cows. Other species used in commercial dairy farming include goats, sheep, and camels. Donkeys in Italy.
      </p>
      <MDBBtn className="btn btn-outline-default btn-md">view</MDBBtn></MDBCol>

    </MDBRow>
    <br                                         />
  </MDBContainer>

  </section>
  <section className="text-center" style={{backgroundImage:"url(https://demo.templatetrip.com/Opencart/OPCTM02/OPCTM051_organic/OPC01/image/catalog/demo/banners/parallex-bg.jpg)"}}>
    <MDBContainer>
      <br />
      <h1 className="pt-2">Testmonials</h1>
      <MDBRow>
        <MDBCol md="4">
          <div className="testmonial ">
            <MDBCardBody>
            <div class="avatar mx-auto" >
            <center>
            <MDBView hover zoom>
              <img 
             src="https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg"
              className="rounded-circle z-depth-1 img-fluid m-3" 
            
              />
            </MDBView>
            </center>
          
          </div>

              <MDBCardTitle className="mt-4">
              Anna Deynah
              </MDBCardTitle>
              <h6 class="font-weight-bold blue-text my-3">Web Designer</h6>
              <MDBCardText> <i class="fas fa-quote-left pr-2"></i>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod
            eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.</MDBCardText>
              <div class="orange-text">
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star-half-alt"> </i>
          </div>
            </MDBCardBody>
          </div>
        </MDBCol>
        <MDBCol md="4">
          <div className="testmonial">
            <MDBCardBody>
            <div class="avatar mx-auto" >
            <center>
            <MDBView hover zoom>
              <img 
             src="https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg"
              className="rounded-circle z-depth-1 img-fluid m-3" 
            
              />
            </MDBView>
            </center>
          
          </div>

              <MDBCardTitle className="mt-4">
              Anna Deynah
              </MDBCardTitle>
              <h6 class="font-weight-bold blue-text my-3">Web Designer</h6>
              <MDBCardText> <i class="fas fa-quote-left pr-2"></i>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod
            eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.</MDBCardText>
              <div class="orange-text">
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star-half-alt"> </i>
          </div>
            </MDBCardBody>
          </div>
        </MDBCol>  
        <MDBCol md="4">
          <div className="testmonial">
            <MDBCardBody>
            <div class="avatar mx-auto" >
            <center>
            <MDBView hover zoom>
              <img 
             src="https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg"
              className="rounded-circle z-depth-1 img-fluid m-3" 
            
              />
            </MDBView>
            </center>
          
          </div>

              <MDBCardTitle className="mt-4">
              Anna Deynah
              </MDBCardTitle>
              <h6 class="font-weight-bold blue-text my-3">Web Designer</h6>
              <MDBCardText> <i class="fas fa-quote-left pr-2"></i>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod
            eos id officiis hic tenetur quae quaerat ad velit ab hic tenetur.</MDBCardText>
              <div class="orange-text">
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star"> </i>
            <i class="fas fa-star-half-alt"> </i>
          </div>
            </MDBCardBody>
          </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  </section>

  <br  />
  <section>


<MDBContainer>
<MDBCard>

<MDBRow>
  <MDBCol md="6">

  
    <div id="map-within-card-2" class="map-container rounded-left" style={{height: "400px"}}>

      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3800.814534927219!2d83.20374331488084!3d17.706219387888243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a39685948502bd9%3A0x32ad04ac7d1931ae!2sSri%20Vijaya%20Visakha%20Milk%20Producers%20Company%20Limited!5e0!3m2!1sen!2sin!4v1595410308036!5m2!1sen!2sin" frameborder="0"
        style={{border:"0"}} allowfullscreen></iframe>
    </div>
   

  </MDBCol>

  <MDBCol md="4" className="col-10  mx-auto text-center py-4">
 
    <h6 class="font-weight-bold grey-text text-uppercase small">Head Office</h6>
    <h5 class="font-weight-normal mb-4">Sri Vijaya Visakha Milk Producers Company Limited</h5>
    <h5 class="font-weight-normal mb-4"> Akkireddypalem, Visakhapatnam, Andhra Pradesh 530012</h5>
    <p class="text-muted font-weight-light mb-0">Phone: +08924 22525<br/>Email: hello@viskha</p>

  </MDBCol>
  </MDBRow>

</MDBCard>


</MDBContainer>

  </section>
  <br  />
 <section style={{
  padding:"30px",
   background:"skyblue"
   
 }}
 className="text-center"
 
 >

   <h1>our partners</h1>
   <br />
 <MDBRow className="text-center">
 <MDBCol md="2">
 <img src="https://demo.templatetrip.com/Opencart/OPCTM02/OPCTM051_organic/OPC01/image/cache/catalog/demo/manufacturer/brand-logo-04-140x100.png" /> 
  </MDBCol>
  <MDBCol md="2">
  <img src="https://demo.templatetrip.com/Opencart/OPCTM02/OPCTM051_organic/OPC01/image/cache/catalog/demo/manufacturer/brand-logo-05-140x100.png" /> 
  </MDBCol>
  <MDBCol md="2">
  <img src="https://demo.templatetrip.com/Opencart/OPCTM02/OPCTM051_organic/OPC01/image/cache/catalog/demo/manufacturer/brand-logo-01-140x100.png" />
  </MDBCol>
  <MDBCol md="2">
  <img src="https://demo.templatetrip.com/Opencart/OPCTM02/OPCTM051_organic/OPC01/image/cache/catalog/demo/manufacturer/brand-logo-03-140x100.png" /> 
  </MDBCol>
  <MDBCol md="2">
  <img src="https://demo.templatetrip.com/Opencart/OPCTM02/OPCTM051_organic/OPC01/image/cache/catalog/demo/manufacturer/brand-logo-02-140x100.png" /> 
  </MDBCol>
  <MDBCol md="2">
  <img src="https://demo.templatetrip.com/Opencart/OPCTM02/OPCTM051_organic/OPC01/image/cache/catalog/demo/manufacturer/brand-logo-02-140x100.png" /> 
  </MDBCol>

 </MDBRow>
 </section>


   </div>
  )
}

export default Card;